import {RadioCardItem} from '~/components/ui/RadioCard';
import {Flex, HStack, VStack} from '@styled-system/jsx';
import {css} from '@styled-system/css';
import {formatMoney} from 'shared/utils/format';

type ProductOptionProps = {
  productId: string
  title: string
  imgSrc: string
  price: number
  hasShipping: boolean
}

const ProductOption = ({productId, title, imgSrc, price, hasShipping}: ProductOptionProps) => {
  return <RadioCardItem value={productId} id={productId}>
    <HStack justify="space-between">
      <HStack>
        <Flex flex={1} minW={75}>
          <img src={imgSrc} alt="" className={css({
            height: '75px',
            objectFit: 'contain',
          })}/>
        </Flex>
        <VStack alignItems="flex-start" alignSelf="flex-start" gap={0}>
          <div className={css({
            fontFamily: 'heading',
            textTransform: 'uppercase',
            fontSize: 'lg',
            fontWeight: '500',
          })}>
            {title}
          </div>
          <div>{formatMoney(price)}{hasShipping && ' + shipping'}</div>
        </VStack>
      </HStack>
    </HStack>
  </RadioCardItem>
}

export default ProductOption;
